import React, { useEffect, useMemo, useState } from "react";
import { Clock, Check, Users, X, FileText, Calendar } from "lucide-react";
import "./shiftCompletionStyles.css";
import swal from "sweetalert";
import { httpAdmin } from "../../../Apis/commonApis";
import moment from "moment";
import { Accordion } from "react-bootstrap";
import { BiSolidDownArrow } from "react-icons/bi";
import { wCategories } from "../../../constants/constants";
import { useSelector } from "react-redux";
import { Checkbox, FormControlLabel } from "@mui/material";
import TaskCheckbox from "./ProxyCheckbox";

const ShiftCompletionPopup = ({ shiftTaskData, closeShiftCompletion }) => {
  const { allShiftData, taskList } = shiftTaskData;
  const { settingData } = useSelector((state) => state.adminPanelSetting);

  // State for the form with separate hour and minute values
  const [checkinDateTimeError, setCheckinDateTimeError] = useState("");
  const [checkoutDateTimeError, setCheckoutDateTimeError] = useState("");
  const [clockInHour, setClockInHour] = useState("");
  const [clockInMinute, setClockInMinute] = useState("");
  const [clockOutHour, setClockOutHour] = useState("");
  const [clockOutMinute, setClockOutMinute] = useState("");
  const [selectedClient, setSelectedClient] = useState(null);
  const [activeTab, setActiveTab] = useState("Tasks");
  const [completedTasks, setCompletedTasks] = useState({});
  const [taskCompletionHours, setTaskCompletionHours] = useState({});
  const [taskCompletionMinutes, setTaskCompletionMinutes] = useState({});
  const [careNotesHour, setCareNotesHour] = useState("");
  const [careNotesMinute, setCareNotesMinute] = useState("");
  const [careNotes, setCareNotes] = useState("");
  const [familyNotesHour, setFamilyNotesHour] = useState("");
  const [familyNotesMinute, setFamilyNotesMinute] = useState("");
  const [familyNotes, setFamilyNotes] = useState("");
  const [shiftData, setSelectedShiftData] = useState({});
  const [wellbeingData, setWellbeingData] = useState({});
  const [taskInputData, setTaskInputData] = useState([]);
  const [selectedCareTeam, setSelectedCareTeam] = useState(
    allShiftData?.shiftMappings?.[0]?.careTeamId ?? ""
  );

  useEffect(() => {
    if (allShiftData) {
      const selecteTeamShiftData = allShiftData?.shiftMappings?.find(
        (item) => item.careTeamId === selectedCareTeam
      );
      let remainingTaskCount = 0;
      const mapClientData = selecteTeamShiftData?.client?.map((citem) => {
        const shiftDate = allShiftData?.shiftDate?.split("T")?.[0];
        const filtereCompletedTasks = taskList?.filter(
          (tItem) =>
            tItem?.shiftDate?.split("T")?.[0] === shiftDate &&
            tItem?.clientId === citem?._id &&
            tItem.status !== "true" &&
            tItem.status !== "omitted"
        );
        const filterByTaskTime = filtereCompletedTasks.filter((item) => {
          const globalTask = item?.globalTask;
          return globalTask?.shiftType?.includes("specific time")
            ? isTimeBetween(
                allShiftData?.startingTime,
                allShiftData?.endingTime,
                globalTask.startTime,
                globalTask.endTime
              )
            : true;
        });
        remainingTaskCount += filterByTaskTime?.length;
        return {
          id: citem._id,
          name: `${citem?.first_Name} ${citem?.last_Name}`,
          tasks: filterByTaskTime,
        };
      });
      setSelectedShiftData({
        ...allShiftData,
        id: allShiftData?._id,
        date: allShiftData?.Date,
        startTime: allShiftData?.startingTime,
        endTime: allShiftData?.endingTime,
        clients: mapClientData,
        remainingTaskCount,
      });
    }
  }, [allShiftData, selectedCareTeam]);

  const handleClientSelect = (client) => {
    setSelectedClient(client.id === selectedClient ? null : client.id);
    setActiveTab("Tasks");
  };

  const handleTaskToggle = (status, task) => {
    const taskId = task._id;
    setCompletedTasks((prev) => ({
      ...prev,
      [taskId]: status,
    }));
    const isTaskWellbeing = task.taskCategory === "wellbeing";
    handleWellbeingDataChange(isTaskWellbeing ? { taskId: task._id } : null);
    const taskType = task.globalTask?.taskType;
    if (inputTasksList.includes(taskType)) {
      handleTaskInputDataChange(taskId, taskType, "", "");
    }
  };

  const handleWellbeingDataChange = (dataParams) => {
    if (dataParams) {
      setWellbeingData((prev) => ({ ...prev, ...dataParams }));
    }
  };

  const handleTaskOmitReasonChange = (taskId, taskType, value) => {
    setTaskInputData((prev) => {
      const findInputObj = prev.find((item) => item.taskId === taskId);

      if (findInputObj) {
        return prev.map((item) => {
          return item.taskId === taskId
            ? {
                ...item,
                omitReason: value,
              }
            : item;
        });
      } else {
        return [
          ...prev,
          {
            taskId,
            taskType: taskType,
            measureValue: "",
            measureType: getMeasurementUnit(taskType) || "kcal",
            omitReason: value,
          },
        ];
      }
    });
  };

  const handleTaskInputDataChange = (taskId, taskType, value1, value2) => {
    setTaskInputData((prev) => {
      const findInputObj = prev.find((item) => item.taskId === taskId);
      if (taskType === "BP") {
        if (findInputObj) {
          return prev.map((item) => {
            return item.taskId === taskId
              ? {
                  ...item,
                  Systolic_BP: {
                    ...item.Systolic_BP,
                    measureValue: value1 ?? item.Systolic_BP?.measureValue,
                  },
                  Diastolic_BP: {
                    ...item.Diastolic_BP,
                    measureValue: value2 ?? item.Diastolic_BP?.measureValue,
                  },
                }
              : item;
          });
        } else {
          return [
            ...prev,
            {
              taskId,
              taskType,
              Systolic_BP: {
                measureValue: "",
                measureType: "mmHg",
              },
              Diastolic_BP: {
                measureValue: "",
                measureType: "mmHg",
              },
            },
          ];
        }
      } else {
        if (findInputObj) {
          return prev.map((item) => {
            return item.taskId === taskId
              ? {
                  ...item,
                  measureValue: value1,
                }
              : item;
          });
        } else {
          return [
            ...prev,
            {
              taskId,
              taskType,
              measureValue: "",
              measureType: getMeasurementUnit(taskType) || "kcal",
              omitReason: "",
            },
          ];
        }
      }
    });
  };

  const handleTaskTimeChange = (taskId, type, value) => {
    if (type === "hour") {
      setTaskCompletionHours({
        ...taskCompletionHours,
        [taskId]: value,
      });
    } else if (type === "minute") {
      setTaskCompletionMinutes({
        ...taskCompletionMinutes,
        [taskId]: value,
      });
    }
  };

  // Convert hours and minutes to HH:MM format for saving
  const getFormattedTime = (hours, minutes) => {
    if (!hours && !minutes) return "";
    const h = hours || "00";
    const m = minutes || "00";
    return `${h}:${m}`;
  };

  function getTrueKeys(data) {
    return Object.keys(data).filter(
      (key) => data[key] === "true" || data[key] === "omitted"
    );
  }

  const handleSave = async () => {
    console.log(shiftData, "shiftData------");
    const checkinDateTime = convertToTimezone(
      allShiftData?.Date,
      clockInHour,
      clockInMinute,
      allShiftData?.timeZone
    );
    const checkoutDateTime = convertToTimezone(
      allShiftData?.Date,
      clockOutHour,
      clockOutMinute,
      allShiftData?.timeZone
    );

    if (!checkinDateTime || !checkoutDateTime) {
      swal(
        "Failed",
        `'Check-in' and 'Check-out' date/time is required,'`,
        "error"
      );
      !checkinDateTime &&
        setCheckinDateTimeError("Check-in date/time is required.");
      !checkoutDateTime &&
        setCheckoutDateTimeError("Check-out date/time is required.");
      return;
    } else {
      setCheckinDateTimeError("");
      setCheckoutDateTimeError("");
    }

    // const checkinDateTime = formatToISOString(shiftData?.date, clockInTime);
    // const checkoutDateTime = formatToISOString(shiftData?.date, clockOutTime);
    const completedTasksIds = getTrueKeys(completedTasks);
    if (shiftData?.remainingTaskCount > 0 && completedTasksIds?.length === 0) {
      swal("Failed", `Select atleast one task to complete.`, "error");
      return;
    }

    let errorText = "";

    const completedTasksData = completedTasksIds.map((tId) => {
      const taskHr = taskCompletionHours[tId];
      const taskMin = taskCompletionMinutes[tId];
      if (!taskHr || !taskMin) {
        errorText = "Selected task time is required.";
      }
      const taskStatus = completedTasks[tId];
      const findInputData = taskInputData.find((tItem) => tItem.taskId === tId);
      const taskType = findInputData?.taskType ?? "";
      let finalData = {};
      const generalData = {
        taskId: tId,
        timestamp: convertToUtcTime(
          allShiftData?.Date,
          taskHr,
          taskMin,
          allShiftData?.timeZone
        ),
        status: taskStatus,
      };
      if (wellbeingData?.taskId === tId || taskType === "Wellbeing") {
        finalData = { ...generalData, ...wellbeingData };
        if (taskStatus === "omitted") {
          if (findInputData?.omitReason?.trim() === "") {
            errorText = "Provide all details of selected tasks.";
          }
          finalData.reason = findInputData?.omitReason;
        }
      } else if (inputTasksList.includes(taskType)) {
        if (taskStatus === "omitted") {
          if (findInputData.omitReason?.trim() === "") {
            errorText = "Provide all details of selected tasks.";
          }
          finalData = {
            ...generalData,
            reason: findInputData?.omitReason,
          };
        } else {
          if (findInputData.measureValue?.trim() === "") {
            errorText = "Provide all details of selected tasks.";
          }
          finalData = {
            ...generalData,
            input: findInputData,
          };
        }
      } else {
        if (taskStatus === "omitted") {
          if (findInputData?.omitReason?.trim() === "") {
            errorText = "Provide all details of selected tasks.";
          }
          finalData = {
            ...generalData,
            reason: findInputData?.omitReason,
          };
        } else {
          finalData = { ...generalData };
        }
      }
      return finalData;
    });

    if (errorText !== "") {
      swal("Failed", `${errorText}`, "error");
      return;
    }

    const notesData = [];
    if (careNotes?.trim() !== "") {
      notesData.push({
        notesData: careNotes,
        notesType: "careteammember",
        timestamp: convertToUtcTime(
          allShiftData?.Date,
          careNotesHour,
          careNotesMinute,
          allShiftData?.timeZone
        ),
      });
    }
    if (familyNotes?.trim() !== "") {
      notesData.push({
        notesData: familyNotes,
        notesType: "family",
        timestamp: convertToUtcTime(
          allShiftData?.Date,
          familyNotesHour,
          familyNotesMinute,
          allShiftData?.timeZone
        ),
      });
    }

    const clientId = shiftData?.clients?.[0]?.id;
    // Implementation for actual reassignment would go here
    const endPointString = "checkinAndcheckout";
    const bodyData = {
      globalShiftId: shiftTaskData?.allShiftData?._id,
      careTeamId: selectedCareTeam,
      clientId,
      careHomeId: shiftTaskData?.allShiftData?.careHomeId,

      checkinDateTime: checkinDateTime,
      checkoutDateTime: checkoutDateTime,
      // checkoutBy: "admin",
      taskIds: completedTasksData,
      status: "true",
      notesData,
      checkindatetime: convertToUtcTime(
        allShiftData?.Date,
        clockInHour,
        clockInMinute,
        allShiftData?.timeZone
      ),
      checkoutdatetime: convertToUtcTime(
        allShiftData?.Date,
        clockInHour,
        clockInMinute,
        allShiftData?.timeZone
      ),
    };
    try {
      const res = await httpAdmin(endPointString, "POST", bodyData, null);
      swal(
        res.status ? "Success" : "Failed",
        res.message,
        res.status ? "success" : "error"
      );
      if (res.status) {
        handleClose();
      }
    } catch (error) {
      if (error.response) {
        swal("Failed", error.response?.data?.message, "error");
      } else if (error.request) {
        console.log(error.request);
      } else {
        swal("Failed", error.message, "error");
      }
      console.log(error.config);
    }

    // Implementation for saving the shift data
  };

  const handleCareTeamChange = (id) => {
    setSelectedCareTeam(id);
  };

  const handleClose = () => {
    closeShiftCompletion();
  };

  const allowedHoursAndMins = useMemo(() => {
    const clockInGrace = settingData?.shift?.ClockInGracePeriodInMin ?? 0;
    const clockOutGrace = settingData?.shift?.ClockOutGracePeriodInMin ?? 0;
    const shiftStart = addMinutesToTime(
      allShiftData?.startingTime,
      -clockInGrace
    );
    const shiftEnd = addMinutesToTime(allShiftData?.endingTime, clockOutGrace);
    const hrs = getAllowedHours(shiftStart, shiftEnd);
    const mins = getAllowedMinutes(+clockInHour, shiftStart, shiftEnd);
    return { hrs, mins };
  }, [allShiftData, settingData]);

  return (
    <div className="shiftCompletionModal index-99">
      <div className="shiftCompletionModalContent">
        {/* Header */}
        <div className="modalHeader">
          <h5 className="modal-title">Complete Proxy Shift</h5>
          <button onClick={handleClose} className="closeButton">
            <X size={24} />
          </button>
        </div>

        {/* Content - Scrollable area */}
        <div className="modalBody">
          <div className="modalBodyContent">
            {/* Shift Details */}
            <div className="shiftDetails">
              <div className="shiftDetailsFlex">
                <div>
                  <div className="dateContainer">
                    <Calendar size={18} className="calendarIcon" />
                    {shiftData?.date}
                  </div>
                  <div className="shiftTime">
                    {shiftData?.startTime} - {shiftData?.endTime}
                  </div>
                </div>
                <div className="caregiverDetails">
                  <div className="caregiverLabel">Caregiver</div>
                  <div className="caregiverInfo">
                    <div className="caregiverIconContainer">
                      <Users size={20} className="caregiverIcon" />
                    </div>
                    <div>
                      <select
                        name="shiftData"
                        style={{ width: "200px" }}
                        id="shiftData"
                        className="form-control"
                        value={selectedCareTeam || ""}
                        onChange={(e) => handleCareTeamChange(e.target.value)}
                      >
                        {/* <option value={""}>select</option> */}
                        {allShiftData?.shiftMappings?.map((item) => (
                          <option value={item?.careTeamId} key={item?._id}>
                            {item?.careteam?.first_Name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Clock In/Out Times */}
            <div className="clockInOutContainer">
              <div>
                <label className="form-label">Clock In Time (24h)</label>
                <div className="timeInputContainer">
                  <div className="clockIconContainer">
                    <Clock size={18} className="clockIcon" />
                  </div>
                  <div className="timeSelectFlex">
                    <select
                      value={clockInHour}
                      onChange={(e) => setClockInHour(e.target.value)}
                      className=" timeSelectHour"
                    >
                      <option
                        value=""
                        style={{ color: "#4B5563", fontWeight: "500" }}
                      >
                        HH
                      </option>
                      {allowedHoursAndMins?.hrs?.map((hour) => (
                        <option
                          key={hour}
                          value={hour.toString().padStart(2, "0")}
                        >
                          {hour.toString().padStart(2, "0")}
                        </option>
                      ))}
                    </select>
                    <span className="timeSeparator">:</span>
                    <select
                      value={clockInMinute}
                      onChange={(e) => setClockInMinute(e.target.value)}
                      className="timeSelectMinute"
                    >
                      <option
                        value=""
                        style={{ color: "#4B5563", fontWeight: "500" }}
                      >
                        {" "}
                        MM
                      </option>
                      {allowedHoursAndMins?.mins?.map((m) => (
                        <option key={m} value={m.toString().padStart(2, "0")}>
                          {m.toString().padStart(2, "0")}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {checkinDateTimeError && (
                  <small className="errorText">{checkinDateTimeError}</small>
                )}
              </div>
              <div>
                <label className="form-label">Clock Out Time (24h)</label>
                <div className="timeInputContainer">
                  <div className="clockIconContainer">
                    <Clock size={18} className="clockIcon" />
                  </div>
                  <div className="timeSelectFlex">
                    <select
                      value={clockOutHour}
                      onChange={(e) => setClockOutHour(e.target.value)}
                      className="timeSelectHour"
                    >
                      <option
                        value=""
                        style={{ color: "#4B5563", fontWeight: "100" }}
                      >
                        HH
                      </option>
                      {allowedHoursAndMins?.hrs?.map((hour) => (
                        <option
                          key={hour}
                          value={hour.toString().padStart(2, "0")}
                        >
                          {hour.toString().padStart(2, "0")}
                        </option>
                      ))}
                    </select>
                    <span className="timeSeparator">:</span>
                    <select
                      value={clockOutMinute}
                      onChange={(e) => setClockOutMinute(e.target.value)}
                      className="timeSelectMinute "
                    >
                      <option
                        value=""
                        style={{ color: "#4B5563", fontWeight: "500" }}
                        className="text-center"
                      >
                        MM
                      </option>
                      {allowedHoursAndMins?.mins?.map((m) => (
                        <option key={m} value={m.toString().padStart(2, "0")}>
                          {m.toString().padStart(2, "0")}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {checkoutDateTimeError && (
                  <small className="errorText">{checkoutDateTimeError}</small>
                )}
              </div>
            </div>

            {/* Clients Section */}
            <div className="clientsSection">
              <div className="clientsHeader">
                <h5 className="clientsTitle">Clients in this shift</h5>
              </div>

              <div className="clientsList">
                {shiftData?.clients?.map((client) => (
                  <div key={client.id}>
                    {/* Client Header - Clickable */}
                    <div
                      className={`clientHeader ${
                        selectedClient === client.id
                          ? "clientHeaderSelected"
                          : ""
                      }`}
                      onClick={() => handleClientSelect(client)}
                    >
                      <div className="clientHeaderFlex">
                        <div className="clientIconContainer">
                          <Users size={16} className="clientIcon" />
                        </div>
                        <div className="clientName">{client.name}</div>
                      </div>
                      {selectedClient === client.id ? (
                        <svg
                          className="clientArrow"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 15l7-7 7 7"
                          />
                        </svg>
                      ) : (
                        <svg
                          className="clientArrow"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      )}
                    </div>

                    {/* Client Details - Expandable */}
                    {selectedClient === client.id && (
                      <div className="clientDetails">
                        {/* Tabs */}
                        <div className="tabBar">
                          <button
                            className={`tabButton ${
                              activeTab === "Tasks" ? "tabButtonActive" : ""
                            }`}
                            onClick={() => setActiveTab("Tasks")}
                          >
                            Tasks
                          </button>
                          <button
                            className={`tabButton ${
                              activeTab === "Care Notes"
                                ? "tabButtonActive"
                                : ""
                            }`}
                            onClick={() => setActiveTab("Care Notes")}
                          >
                            Care Notes
                          </button>
                          <button
                            className={`tabButton ${
                              activeTab === "Family Notes"
                                ? "tabButtonActive"
                                : ""
                            }`}
                            onClick={() => setActiveTab("Family Notes")}
                          >
                            Family Notes
                          </button>
                        </div>

                        {/* Tab Content */}
                        {activeTab === "Tasks" && (
                          <>
                            <div className="tasksSummary">
                              {
                                client?.tasks?.filter(
                                  (t) => completedTasks[t._id] || t.completed
                                ).length
                              }{" "}
                              of {client?.tasks?.length} Tasks Completed
                            </div>
                            <div className="tasksList">
                              {client.tasks?.map((task, tIndex) => {
                                const globalTask = task.globalTask;
                                const taskTime =
                                  globalTask?.shiftType?.includes(
                                    "specific time"
                                  )
                                    ? `${globalTask?.startTime}-${globalTask?.endTime}`
                                    : "00:00 - 23:59";
                                let taskName = globalTask?.taskName;
                                let taskType = globalTask?.taskType;
                                const taskCheckStatus =
                                  completedTasks[task._id];
                                const conditionsToShowMed =
                                  globalTask?.medName &&
                                  globalTask?.prn?.toLowerCase() === "no";
                                const conditionsToShowPrn =
                                  globalTask?.medName &&
                                  globalTask?.prn?.toLowerCase() === "yes";
                                const isTaskWellbeing =
                                  task.taskCategory === "wellbeing";
                                const showInputFields =
                                  isTaskWellbeing ||
                                  inputTasksList.includes(taskType);
                                if (conditionsToShowMed) {
                                  taskName = "Medication Reminder";
                                  taskType = globalTask?.NM;
                                } else if (conditionsToShowPrn) {
                                  taskName = "PRN Med";
                                  taskType = globalTask?.NM;
                                } else if (isTaskWellbeing) {
                                  taskName = "Wellbeing";
                                  taskType = "Wellbeing";
                                }
                                return (
                                  <div key={task._id} className="taskItem">
                                    <div className="taskItemFlex mb-2">
                                      <div className="taskInfo">
                                        <div className="taskIconContainer">
                                          <FileText
                                            size={16}
                                            className="taskIcon"
                                          />
                                        </div>
                                        <div>
                                          <div className="taskCategory">
                                            {taskName}
                                          </div>
                                          <div className="taskName">
                                            {taskType}
                                          </div>
                                          <div className="taskDescription">
                                            Task time: {taskTime}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="d-flex gap-3 items-end">
                                        {/* Timestamp only appears when task is completed */}
                                        {(taskCheckStatus === "true" ||
                                          taskCheckStatus === "omitted") && (
                                          <div className="taskTimestamp">
                                            <span className="timestampLabel">
                                              Timestamp:
                                            </span>
                                            <div className="timeInputContainer">
                                              <div className="clockIconContainer">
                                                <Clock
                                                  size={18}
                                                  className="clockIcon"
                                                />
                                              </div>
                                              <div className="timeSelectFlex">
                                                <select
                                                  value={
                                                    taskCompletionHours[
                                                      task._id
                                                    ] || ""
                                                  }
                                                  onChange={(e) =>
                                                    handleTaskTimeChange(
                                                      task._id,
                                                      "hour",
                                                      e.target.value
                                                    )
                                                  }
                                                  className="timeSelectHour"
                                                >
                                                  <option
                                                    value=""
                                                    style={{
                                                      color: "#4B5563",
                                                      fontWeight: "500",
                                                    }}
                                                  >
                                                    HH
                                                  </option>
                                                  {allowedHoursAndMins?.hrs?.map(
                                                    (hour) => (
                                                      <option
                                                        key={hour}
                                                        value={hour
                                                          .toString()
                                                          .padStart(2, "0")}
                                                      >
                                                        {hour
                                                          .toString()
                                                          .padStart(2, "0")}
                                                      </option>
                                                    )
                                                  )}
                                                </select>
                                                <span className="timeSeparator">
                                                  :
                                                </span>
                                                <select
                                                  value={
                                                    taskCompletionMinutes[
                                                      task._id
                                                    ] || ""
                                                  }
                                                  onChange={(e) =>
                                                    handleTaskTimeChange(
                                                      task._id,
                                                      "minute",
                                                      e.target.value
                                                    )
                                                  }
                                                  className="timeSelectMinute "
                                                >
                                                  <option
                                                    value=""
                                                    style={{
                                                      color: "#4B5563",
                                                      fontWeight: "500",
                                                    }}
                                                  >
                                                    MM
                                                  </option>
                                                  {allowedHoursAndMins?.mins?.map(
                                                    (m) => (
                                                      <option
                                                        key={m}
                                                        value={m
                                                          .toString()
                                                          .padStart(2, "0")}
                                                      >
                                                        {m
                                                          .toString()
                                                          .padStart(2, "0")}
                                                      </option>
                                                    )
                                                  )}
                                                </select>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                        <div>
                                          <TaskCheckbox
                                            task={task}
                                            completedTasks={completedTasks}
                                            handleCheckboxSelect={
                                              handleTaskToggle
                                            }
                                          />
                                          {/* <FormControlLabel
                                            control={
                                              <Checkbox
                                                checked={
                                                  completedTasks[task._id] ||
                                                  false
                                                }
                                                onChange={(e) =>
                                                  handleTaskToggle(e, task)
                                                }
                                                color="secondary"
                                                sx={{
                                                  transform: "scale(1.5)",
                                                  marginTop: "24px",
                                                }}
                                              />
                                            }
                                            label=""
                                          /> */}
                                        </div>
                                      </div>
                                    </div>
                                    {((taskCheckStatus === "true" &&
                                      showInputFields) ||
                                      taskCheckStatus === "omitted") && (
                                      <Accordion
                                        defaultActiveKey={tIndex}
                                        className="colorIcon wellbeingIcons"
                                        style={{
                                          color: "#c1c1c1",
                                          fontSize: "18px",
                                        }}
                                      >
                                        <Accordion.Item eventKey={tIndex}>
                                          <Accordion.Header
                                            style={{ borderBottom: "none" }}
                                          >
                                            {taskCheckStatus === "omitted"
                                              ? "Enter omit reason"
                                              : isTaskWellbeing
                                              ? "Select appropriate emoticon"
                                              : "Enter input value."}
                                            {/* <BiSolidDownArrow /> */}
                                          </Accordion.Header>
                                          <Accordion.Body>
                                            {taskCheckStatus === "omitted" ? (
                                              <>
                                                <input
                                                  className="notesTextarea form-control"
                                                  placeholder="Please enter reason here for omiting task."
                                                  type="text"
                                                  value={
                                                    taskInputData.find(
                                                      (tItem) =>
                                                        tItem.taskId ===
                                                        task._id
                                                    )?.omitReason || ""
                                                  }
                                                  onChange={(e) =>
                                                    handleTaskOmitReasonChange(
                                                      task._id,
                                                      taskType,
                                                      e.target.value
                                                    )
                                                  }
                                                ></input>
                                              </>
                                            ) : (
                                              <>
                                                {isTaskWellbeing ? (
                                                  <ul>
                                                    {wCategories.map(
                                                      (wellCat, wIndex) => {
                                                        const ratingCount = [
                                                          1, 2, 3, 4, 5, 6,
                                                        ];
                                                        const rating =
                                                          wellbeingData?.[
                                                            wellCat.wCat
                                                          ] ?? 0;
                                                        return (
                                                          <li key={wIndex * 20}>
                                                            <label
                                                              style={{
                                                                width: "40%",
                                                              }}
                                                            >
                                                              {
                                                                wellCat.displayName
                                                              }
                                                            </label>
                                                            <div
                                                              style={{
                                                                width: "50%",
                                                                display: "flex",
                                                                gap: "12px",
                                                              }}
                                                            >
                                                              {ratingCount.map(
                                                                (count) => (
                                                                  <button
                                                                    onClick={() =>
                                                                      handleWellbeingDataChange(
                                                                        {
                                                                          [wellCat.wCat]:
                                                                            count,
                                                                        }
                                                                      )
                                                                    }
                                                                  >
                                                                    <img
                                                                      className={
                                                                        rating ===
                                                                        count
                                                                          ? "wellbineColor"
                                                                          : ""
                                                                      }
                                                                      src={`/admin/images/is${count}.svg`}
                                                                    />
                                                                  </button>
                                                                )
                                                              )}
                                                            </div>
                                                          </li>
                                                        );
                                                      }
                                                    )}
                                                  </ul>
                                                ) : (
                                                  <div className="d-flex gap-2">
                                                    {taskType === "BP" ? (
                                                      <>
                                                        <span>Systolic_BP</span>
                                                        <input
                                                          className="notesTextarea form-control"
                                                          placeholder="Enter value here..."
                                                          type="number"
                                                          name="Systolic_BP"
                                                          value={
                                                            taskInputData.find(
                                                              (tItem) =>
                                                                tItem.taskId ===
                                                                task._id
                                                            )?.Systolic_BP
                                                              ?.measureValue ||
                                                            ""
                                                          }
                                                          onChange={(e) =>
                                                            handleTaskInputDataChange(
                                                              task._id,
                                                              globalTask?.taskType,
                                                              e.target.value,
                                                              null
                                                            )
                                                          }
                                                        ></input>
                                                        <span>
                                                          Diastolic_BP
                                                        </span>
                                                        <input
                                                          className="notesTextarea form-control"
                                                          placeholder="Enter value here..."
                                                          type="number"
                                                          name="Diastolic_BP"
                                                          value={
                                                            taskInputData.find(
                                                              (tItem) =>
                                                                tItem.taskId ===
                                                                task._id
                                                            )?.Diastolic_BP
                                                              ?.measureValue ||
                                                            ""
                                                          }
                                                          onChange={(e) =>
                                                            handleTaskInputDataChange(
                                                              task._id,
                                                              globalTask?.taskType,
                                                              null,
                                                              e.target.value
                                                            )
                                                          }
                                                        ></input>
                                                      </>
                                                    ) : (
                                                      <input
                                                        className="notesTextarea form-control"
                                                        placeholder={
                                                          intakePlaceHolderValues[
                                                            taskType
                                                          ] ??
                                                          "Enter value here..."
                                                        }
                                                        type="number"
                                                        value={
                                                          taskInputData.find(
                                                            (tItem) =>
                                                              tItem.taskId ===
                                                              task._id
                                                          )?.measureValue || ""
                                                        }
                                                        onChange={(e) =>
                                                          handleTaskInputDataChange(
                                                            task._id,
                                                            globalTask?.taskType,
                                                            e.target.value
                                                          )
                                                        }
                                                      ></input>
                                                    )}
                                                    <label className="ms-2">
                                                      {getMeasurementUnit(
                                                        taskType
                                                      ) || "kcal"}
                                                    </label>
                                                  </div>
                                                )}
                                              </>
                                            )}
                                          </Accordion.Body>
                                        </Accordion.Item>
                                      </Accordion>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          </>
                        )}

                        {activeTab === "Care Notes" && (
                          <div>
                            <div className="taskTimestamp">
                              <span className="timestampLabel">Timestamp:</span>
                              <div className="timeInputContainer">
                                <div className="clockIconContainer">
                                  <Clock size={18} className="clockIcon" />
                                </div>
                                <div className="timeSelectFlex">
                                  <select
                                    value={careNotesHour}
                                    onChange={(e) =>
                                      setCareNotesHour(e.target.value)
                                    }
                                    className="timeSelectHour"
                                  >
                                    <option
                                      value=""
                                      style={{
                                        color: "#4B5563",
                                        fontWeight: "500",
                                      }}
                                    >
                                      HH
                                    </option>
                                    {allowedHoursAndMins?.hrs?.map((hour) => (
                                      <option
                                        key={hour}
                                        value={hour.toString().padStart(2, "0")}
                                      >
                                        {hour.toString().padStart(2, "0")}
                                      </option>
                                    ))}
                                  </select>
                                  <span className="timeSeparator">:</span>
                                  <select
                                    value={careNotesMinute}
                                    onChange={(e) =>
                                      setCareNotesMinute(e.target.value)
                                    }
                                    className="timeSelectMinute"
                                  >
                                    <option
                                      value=""
                                      style={{
                                        color: "#4B5563",
                                        fontWeight: "500",
                                      }}
                                    >
                                      MM
                                    </option>
                                    {allowedHoursAndMins?.mins?.map((min) => (
                                      <option
                                        key={min}
                                        value={min.toString().padStart(2, "0")}
                                      >
                                        {min.toString().padStart(2, "0")}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                            <textarea
                              className="notesTextarea form-control mt-3"
                              placeholder="Enter care notes here..."
                              value={careNotes}
                              onChange={(e) => setCareNotes(e.target.value)}
                            ></textarea>
                          </div>
                        )}

                        {activeTab === "Family Notes" && (
                          <div>
                            <div className="notesTimestamp">
                              <span className="timestampLabel">Timestamp:</span>
                              <div className="timeInputContainer">
                                <div className="clockIconContainer">
                                  <Clock size={18} className="clockIcon" />
                                </div>
                                <div className="timeSelectFlex">
                                  <select
                                    value={familyNotesHour}
                                    onChange={(e) =>
                                      setFamilyNotesHour(e.target.value)
                                    }
                                    className="timeSelectHour"
                                  >
                                    <option
                                      value=""
                                      style={{
                                        color: "#4B5563",
                                        fontWeight: "500",
                                      }}
                                    >
                                      HH
                                    </option>
                                    {allowedHoursAndMins?.hrs?.map((hour) => (
                                      <option
                                        key={hour}
                                        value={hour.toString().padStart(2, "0")}
                                      >
                                        {hour.toString().padStart(2, "0")}
                                      </option>
                                    ))}
                                  </select>
                                  <span className="timeSeparator">:</span>
                                  <select
                                    value={familyNotesMinute}
                                    onChange={(e) =>
                                      setFamilyNotesMinute(e.target.value)
                                    }
                                    className="timeSelectMinute"
                                  >
                                    <option
                                      value=""
                                      style={{
                                        color: "#4B5563",
                                        fontWeight: "500",
                                      }}
                                    >
                                      MM
                                    </option>
                                    {allowedHoursAndMins?.mins?.map((min) => (
                                      <option
                                        key={min}
                                        value={min.toString().padStart(2, "0")}
                                      >
                                        {min.toString().padStart(2, "0")}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                            <textarea
                              className="notesTextarea form-control mt-3"
                              placeholder="Enter family notes here..."
                              value={familyNotes}
                              onChange={(e) => setFamilyNotes(e.target.value)}
                            ></textarea>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="modalFooter">
          <button className="btn cancelButton" onClick={handleClose}>
            Cancel
          </button>
          <button className="btn saveButton" onClick={handleSave}>
            Save Shift
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShiftCompletionPopup;

export function isTimeBetween(startTime, endTime, taskStartTime, taskEndTime) {
  const toMinutes = (timeStr) => {
    if (timeStr) {
      const [hours, minutes] = timeStr?.split(":")?.map(Number);
      return hours * 60 + minutes;
    }
    return 0;
  };
  const start = toMinutes(startTime);
  const end = toMinutes(endTime);
  const taskStart = toMinutes(taskStartTime);
  const taskEnd = toMinutes(taskEndTime);

  // If end is less than start, the time range spans midnight (e.g., 22:00 to 06:00)
  return taskEnd > start && taskStart < end;
}

const getAllowedHours = (start, end) => {
  const [startH, startM] = start?.split(":")?.map(Number);
  const [endH, endM] = end?.split(":")?.map(Number);

  if (startH < endH || (startH === endH && startM < endM)) {
    return Array.from({ length: endH - startH + 1 }, (_, i) => startH + i);
  } else if (startH === endH && startM === endM) {
    return [startH]; // same time
  } else {
    // Cross-midnight case
    return [
      ...Array.from({ length: 24 - startH }, (_, i) => startH + i),
      ...Array.from({ length: endH + 1 }, (_, i) => i),
    ];
  }
};

const getAllowedMinutes = (currentHour, start, end) => {
  const [startH, startM] = start?.split(":")?.map(Number);
  const [endH, endM] = end?.split(":")?.map(Number);

  // if (startH === endH) {
  //   if (currentHour === startH) {
  //     return Array.from({ length: endM - startM }, (_, i) => startM + i);
  //   }
  //   return [];
  // }

  // if (currentHour === startH) {
  //   return Array.from({ length: 60 - startM }, (_, i) => startM + i);
  // }

  // if (currentHour === endH) {
  //   return Array.from({ length: endM }, (_, i) => i);
  // }

  return Array.from({ length: 60 }, (_, i) => i); // full range for middle hours
};

function convertToTimezone(date, hours, minutes, timeZone) {
  // Combine date and time first
  if (hours === "" || minutes === "") {
    return null;
  }
  const dateTime = `${date} ${String(hours).padStart(2, "0")}:${String(
    minutes
  ).padStart(2, "0")}`;

  // Parse in timezone
  const zonedTime = moment.tz(dateTime, "YYYY-MM-DD HH:mm", timeZone);

  // Return ISO string (converted to UTC)
  return zonedTime.toISOString();
}

function convertToUtcTime(date, hour, min, timeZone) {
  const dateTimeString = `${date}T${hour}:${min}`;
  const dateTimeWithTimeZone = moment.tz(dateTimeString, timeZone);
  const dateTimeUTC = dateTimeWithTimeZone.clone().utc();
  const string = dateTimeUTC.toDate();
  return new Date(string);
}

const inputTasksList = [
  "BP",
  "Weight",
  "Temperature",
  "Pulse Oximeter",
  "Blood Glucose",
  "Heart Rate",
  "Respiratory Rate",
  "Daily Liquid Intake",
  "Daily Liquid Leakage",
  "Intake",
  "Leakage",
  "Breakfast",
  "Lunch",
  "Evening Tea",
  "Dinner",
  "Snack",
];

const intakePlaceHolderValues = {
  Breakfast: "Breakfast meal is typically around 400kcal",
  Lunch: "Lunch meal is typically around 600kcal",
  "Evening Tea": "Evening Tea meal is typically around 400kcal",
  Dinner: "Dinner meal is typically around 600kcal",
  Snack: "Snacks meal is typically around 300kcal",
};

const getMeasurementUnit = (healthType) => {
  switch (healthType) {
    case "BP":
      return "mmHg";
    case "Weight":
      return "kg";
    case "Temperature":
      return "°C";
    case "Pulse Oximeter":
      return "%SPO2";
    case "Blood Glucose":
      return "mmol/L";
    case "Heart Rate":
    case "Respiratory Rate":
      return "bpm";
    case "Daily Liquid Intake":
    case "Daily Liquid Intake":
      return "ml";
    case "Intake":
    case "Breakfast":
    case "Lunch":
    case "Evening Tea":
    case "Dinner":
    case "Snack":
      return "kcal";
    default:
      return "";
  }
};

function addMinutesToTime(timeStr, minutesToAdd) {
  const [hours, minutes] = timeStr?.split(":")?.map(Number);

  // Create a base date with today's date
  const date = new Date();
  date.setHours(hours, minutes, 0, 0); // Set hours and minutes

  // Add or subtract minutes
  date.setMinutes(date.getMinutes() + minutesToAdd);

  // Format back to "HH:mm"
  const newHours = String(date.getHours()).padStart(2, "0");
  const newMinutes = String(date.getMinutes()).padStart(2, "0");

  return `${newHours}:${newMinutes}`;
}
